module.exports = function() {
  return new Worker(__webpack_public_path__ + "9a446ed1bd6c6c619d96.worker.js");
};